import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Sparkles } from 'lucide-react';

const API_BASE_URL = 'https://rudrakshenterprises.liveindiatech.com/rudraksh_backend';
export default function Hero({ activeCategory, setActiveCategory, setCurrentPage }) {
    const slides = [
        {
            id: 'all',
            title: "Traditional Purity & Wellness",
            description: "Explore our complete exclusive range of Puja Samagri, Herbal, Jaivik, Ayurvedic, and Organic goods.",
            image: "/banner1.jpg",
            fallbackImage: "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=1600&q=80",
            badge: "100% Certified Pure & Natural"
        },
        {
            id: 'puja',
            title: "Divine & Shuddh Puja Samagri",
            description: "Hawan samagri, pure incense, chandan, kumkum, and all ritual essentials for daily prayers.",
            image: "/banner2.jpg",
            fallbackImage: "https://images.unsplash.com/photo-1609137144813-752467208112?auto=format&fit=crop&w=1600&q=80",
            badge: "1. Puja Samagri Essentials"
        },
        {
            id: 'herbal',
            title: "Pure & Natural Herbal Products",
            description: "Nourish your body and hair with authentic herbal oils, skincare, and natural extracts.",
            image: "/banner3.jpg",
            fallbackImage: "https://images.unsplash.com/photo-1608248597359-994b5952f446?auto=format&fit=crop&w=1600&q=80",
            badge: "2. Herbal Products"
        },
        {
            id: 'jaivik',
            title: "Certified Jaivik (Chemical-Free) Goods",
            description: "Directly harvested pure Jaivik food items, grains, and spices cultivated through sustainable farming.",
            image: "/banner4.jpg",
            fallbackImage: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1600&q=80",
            badge: "3. Jaivik Products"
        },
        {
            id: 'ayurvedic',
            title: "Authentic Ayurvedic Formulations",
            description: "Traditional immunity boosters, Chyawanprash, and classical medicines formulated according to ancient texts.",
            image: "/banner5.jpg",
            fallbackImage: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=1600&q=80",
            badge: "4. Ayurvedic Products"
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    // Auto slide every 5 seconds
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    const currentBanner = slides[currentIndex];

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    return (
        // Mobile ke liye height ko compact aur reference image jaisa banaya gaya hai
        <div id="home" className="relative w-full h-[240px] sm:h-[380px] md:h-[520px] lg:h-[620px] bg-gray-950 overflow-hidden shadow-md">

            {/* Background Full Banner Image */}
            <div className="absolute inset-0 w-full h-full">
                <img
                    src={currentBanner.image}
                    onError={(e) => { e.target.onerror = null; e.target.src = currentBanner.fallbackImage; }}
                    alt={currentBanner.title}
                    className="w-full h-full object-cover object-center transition-all duration-1000 transform scale-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
            </div>

            {/* Left Navigation Arrow */}
            <button
                onClick={handlePrev}
                className="absolute left-2 sm:left-5 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-orange-600 text-white p-1.5 sm:p-3 rounded-full backdrop-blur-md transition border border-white/20 shadow-lg cursor-pointer"
            >
                <ChevronLeft size={18} className="sm:w-6 sm:h-6" />
            </button>

            {/* Right Navigation Arrow */}
            <button
                onClick={handleNext}
                className="absolute right-2 sm:right-5 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-orange-600 text-white p-1.5 sm:p-3 rounded-full backdrop-blur-md transition border border-white/20 shadow-lg cursor-pointer"
            >
                <ChevronRight size={18} className="sm:w-6 sm:h-6" />
            </button>

            {/* Center/Bottom Content Overlay with optimized spacing for mobile */}
            <div className="absolute inset-0 z-10 flex flex-col justify-end p-3 sm:p-8 md:p-12 max-w-4xl">
                <div className="inline-flex items-center gap-1 bg-orange-600 text-white px-2 py-0.5 sm:px-3 sm:py-1 rounded text-[10px] sm:text-xs font-bold w-max uppercase tracking-wider mb-1 sm:mb-2 shadow">
                    <Sparkles size={12} /> {currentBanner.badge}
                </div>

                <h1 className="text-lg sm:text-3xl md:text-5xl font-extrabold text-white drop-shadow-md tracking-tight leading-snug">
                    {currentBanner.title}
                </h1>

                <p className="text-gray-200 text-[11px] sm:text-sm md:text-base mt-1 sm:mt-2 max-w-xl drop-shadow line-clamp-1 sm:line-clamp-2">
                    {currentBanner.description}
                </p>

                <div className="mt-2 sm:mt-4">
                    <button
                        onClick={(e) => {
                            if (typeof setActiveCategory === 'function') {
                                setActiveCategory('all', e);
                            }
                            if (typeof setCurrentPage === 'function') {
                                setCurrentPage('category', e);
                            }
                        }}
                        className="inline-flex items-center gap-1.5 bg-orange-600 hover:bg-orange-700 text-white font-bold px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-xl shadow-md transition text-[11px] sm:text-sm cursor-pointer border-none"
                    >
                        Explore Collection →
                    </button>
                </div>
            </div>

            {/* Bottom Dots Indicator */}
            <div className="absolute bottom-3 right-4 sm:right-8 z-20 flex gap-1.5">
                {slides.map((slide, idx) => (
                    <button
                        key={slide.id}
                        onClick={() => setCurrentIndex(idx)}
                        className={`h-1.5 sm:h-2 rounded-full transition-all duration-300 ${currentIndex === idx ? 'w-5 sm:w-8 bg-orange-500' : 'w-1.5 sm:w-2 bg-white/50 hover:bg-white'
                            }`}
                    />
                ))}
            </div>

        </div>
    );
}